import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--turnover"
export default class extends Controller {
  static targets = ["toggle", "label"]

  // Reverse charge alone does not decide domestic turnover. Preserve the user choice.
  disableTurnover() {
    if (this.hasToggleTarget) {
      this.toggleTarget.disabled = false
    }

    if (this.hasLabelTarget) {
      this.labelTarget.classList.remove("disabled")
    }
  }

  enableTurnover() {
    if (this.hasToggleTarget) {
      this.toggleTarget.disabled = false
    }

    if (this.hasLabelTarget) {
      this.labelTarget.classList.remove("disabled")
    }
  }
}
